import api from './api';

const API_GATEWAY_URL_CONTENT = process.env.API_GATEWAY_URL_CONTENT;
const API_GATEWAY_URL_PRODUCT = process.env.API_GATEWAY_URL_PRODUCT;

const getListProductKnowledgeNews = async (arg, isUseGatewayAPI?) => {
  const { category = '', page = 0, size = 9 } = arg || {};

  return api.get(
    `content/v1/product-knowledge?content-category=${encodeURIComponent(
      category
    )}&page=${page}&size=${size}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getProductKnowledgeHeroV2 = (payload, isUseGatewayAPI?) => {
  // contentCategory Value
  //  all: 'all',
  //  mobil-baru: 'mobil-baru',
  //  servis: 'service',
  //  lainnya: 'lainnya',
  const params = new URLSearchParams(payload).toString();
  return api.get(
    `content/v2/product-knowledge/hero${params ? `?${params}` : ''}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getProductKnowledgeDetail = ({ slug, city }, isUseGatewayAPI?) =>
  api.get(
    `product/v1/product-knowledge-details/${encodeURIComponent(slug)}?city=${city}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );

const getProductKnowledgeArticleDetail = (slug, isUseGatewayAPI?) =>
  api.get(
    `content/v1/product-knowledge/slug/${encodeURIComponent(slug)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );

const getListFaq = () => api.get(`content/v1/faq?type=CONTENT&code=${3}`, {}, false, false, false);

const getAnotherProductKnowledge = (isUseGatewayAPI?) => {
  const size = 4;
  return api.get(
    `content/v1/product-knowledge?page=${0}&size=${size}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getAnotherProductKnowledgeHero = (arg, isUseGatewayAPI?) => {
  const { category = '' } = arg || {};
  return api.get(
    `content/v2/product-knowledge/hero?contentCategory=${encodeURIComponent(category)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getAnotherProductKnowledgeNational = () => {
  return api.get(`content/v1/product-knowledge/national`, {}, false, false, false);
};

export default {
  getListProductKnowledgeNews,
  getProductKnowledgeHeroV2,
  getProductKnowledgeArticleDetail,
  getProductKnowledgeDetail,
  getListFaq,
  getAnotherProductKnowledge,
  getAnotherProductKnowledgeHero,
  getAnotherProductKnowledgeNational,
};
